import { useState } from 'react';

import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';
import { isCookiebotUiRedesignTreatment } from '@/utils/cookieConsent/getCookiebotConsentUiFlags';

/**
 * Returns whether the user is in the CookiebotUiRedesign treatment, pinned to
 * the SSR-baked value for the lifetime of the session.This prevents mid-session
 * variant flips (from AmplitudeProvider re-fetching) from unmounting CookieConsent
 * after it has already been shown.
 *
 * Exposure tracking still uses the live context value useAmplitudeExperimentBase.
 */
export const useCookiebotUiRedesignExperiment = () => {
    useAmplitudeExperimentBase(
        AmplitudeExperiments.CookiebotUiRedesign,
        AmplitudeVariants.CookiebotUiRedesign.Treatment
    );

    const [isTreatment] = useState(
        () =>
            typeof window !== 'undefined' &&
            isCookiebotUiRedesignTreatment(window.__amplitudeExperiments?.variants ?? {})
    );

    return isTreatment;
};
